const BOOKING_MODE = {
  DATEANDTIME: 1,
  DATEONLY: 2,
  TICKET: 3,
};

export default BOOKING_MODE;
